(function() {
  if (window.bundleQuantityInitialized) return;
  window.bundleQuantityInitialized = true;

  function init() {
    const bundleContainer = document.querySelector('[data-bundle-container]');
    if (!bundleContainer) return;

    // Lit la quantité du selector principal
    // qty 1 → max 1 | qty 2 → max 2 | qty 3 → max 3 | qty 4+ → pas de limite
    // Pas de selector trouvé → pas de limite
    function getMaxBundleQuantity() {
      const input = document.querySelector('input[name="quantity"]');
      if (!input) return 999;
      const qty = parseInt(input.value) || 1;
      return qty >= 4 ? 999 : qty;
    }

    function getCurrentBundleTotal() {
      let total = 0;
      bundleContainer.querySelectorAll('[data-quantity-input]').forEach(function(i) {
        total += parseInt(i.value) || 0;
      });
      return total;
    }

    function updateMinusButton(minusBtn, value) {
      minusBtn.classList.toggle('active', value > 0);
    }

    function updateAllPlusButtons() {
      const max = getMaxBundleQuantity();
      const total = getCurrentBundleTotal();
      bundleContainer.querySelectorAll('[data-bundle-item]').forEach(function(item) {
        const plusBtn = item.querySelector('[data-quantity-plus]');
        if (!plusBtn) return;
        const blocked = total >= max;
        plusBtn.disabled = blocked;
        plusBtn.style.opacity = blocked ? '0.3' : '1';
        plusBtn.style.cursor  = blocked ? 'not-allowed' : 'pointer';
      });
    }

    // Si la quantité max diminue, retire des items du bundle en excès
    function adjustBundleToLimit() {
      const max = getMaxBundleQuantity();
      let total = getCurrentBundleTotal();
      if (total <= max) { updateAllPlusButtons(); return; }

      const items = Array.from(bundleContainer.querySelectorAll('[data-bundle-item]')).reverse();
      for (const item of items) {
        if (total <= max) break;
        const input    = item.querySelector('[data-quantity-input]');
        const minusBtn = item.querySelector('[data-quantity-minus]');
        if (!input) continue;
        const current  = parseInt(input.value) || 0;
        const toRemove = Math.min(current, total - max);
        if (toRemove > 0) {
          const newVal = current - toRemove;
          input.value  = newVal;
          total       -= toRemove;
          updateMinusButton(minusBtn, newVal);
          item.classList.toggle('is-selected', newVal > 0);
        }
      }
      updateAllPlusButtons();
    }

    // Attach events
    bundleContainer.querySelectorAll('[data-bundle-item]').forEach(function(item) {
      const input    = item.querySelector('[data-quantity-input]');
      const minusBtn = item.querySelector('[data-quantity-minus]');
      const plusBtn  = item.querySelector('[data-quantity-plus]');
      if (!input || !minusBtn || !plusBtn) return;

      updateMinusButton(minusBtn, parseInt(input.value) || 0);

      minusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt(input.value) || 0;
        if (current > 0) {
          const newVal = current - 1;
          input.value  = newVal;
          updateMinusButton(minusBtn, newVal);
          item.classList.toggle('is-selected', newVal > 0);
          updateAllPlusButtons();
        }
      });

      plusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const max     = getMaxBundleQuantity();
        const total   = getCurrentBundleTotal();
        const current = parseInt(input.value) || 0;
        const maxItem = parseInt(input.getAttribute('max')) || 99;
        if (total < max && current < maxItem) {
          const newVal = current + 1;
          input.value  = newVal;
          updateMinusButton(minusBtn, newVal);
          item.classList.toggle('is-selected', newVal > 0);
          updateAllPlusButtons();
        }
      });
    });

    // Init
    adjustBundleToLimit();

    // Écoute le quantity selector
    const mainInput = document.querySelector('input[name="quantity"]');
    if (mainInput) {
      mainInput.addEventListener('change', adjustBundleToLimit);
      mainInput.addEventListener('input',  adjustBundleToLimit);
      new MutationObserver(adjustBundleToLimit)
        .observe(mainInput, { attributes: true, attributeFilter: ['value'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
